"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "marzano-appio": {
    "40b2bd58": [{
      "hkey": "a05e7ebe",
      "slug": "ameglio-civitella",
      "name": "Ameglio-Civitella",
      "primary": true,
      "skipSearch": false
    }],
    "ameglio": [{
      "hkey": "a05e7ebe",
      "slug": "ameglio-civitella",
      "name": "Ameglio-Civitella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "63632a5a": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "skipSearch": false
    }],
    "terracorpo": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b194bab7": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "skipSearch": false
    }],
    "valle-cupa": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marzano-appio"
    }],
    "1081e4ff": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "skipSearch": false
    }],
    "vallecupa": [{
      "hkey": "41b9a330",
      "slug": "terracorpo-vallecupa-torello",
      "name": "Terracorpo-Vallecupa-Torello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "marzano-appio"
    }],
    "d1ba0066": [{
      "hkey": "705e1dcf",
      "slug": "marzano-appio",
      "name": "Marzano Appio",
      "primary": true,
      "skipSearch": false
    }],
    "le-mura": [{
      "hkey": "705e1dcf",
      "slug": "marzano-appio",
      "name": "Marzano Appio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;